import { render, staticRenderFns } from "./BookingPriceTable.vue?vue&type=template&id=759abd5f"
import script from "./BookingPriceTable.vue?vue&type=script&lang=js"
export * from "./BookingPriceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports